<!-- div *ngIf="hasLoaded" -->
<div class="animated fadeIn animate__faster d-none d-lg-block help-button" (click)="openChat()">
  <img src="/assets/support/support_icon.png" alt="Soporte" />
  <div class="notify" *ngIf="hasNotification">
    <div class="animated swing bell"></div>
  </div>
</div>

<div
  class="animated animate__faster chat-container"
  [class.slideOutDown]="changingOptions"
  [class.slideInUp]="!changingOptions"
  *ngIf="chat"
>
  <div class="chat-header" (click)="chat = !chat">
    <h4 class="header-title">Soporte</h4>
    <app-icons class="close-icon" [type]="'arrow-fill'" [color]="'#ffffff'"></app-icons>
  </div>
  <div class="chat-body">
    <div class="animated fadeIn animate__faster">
      <h1 class="support-title" [innerHTML]="currentOption?.title"></h1>
      <ng-container *ngFor="let option of currentOption?.options">
        <div class="support-item" (click)="setOption(option)" *ngIf="!optionHide(option)">
          <div class="support-image" *ngIf="option.icon">
            <img class="image" [src]="option.icon" [alt]="option.label" />
          </div>
          <div class="support-text">
            <p class="text">{{ option.label }}</p>
          </div>
          <div class="notify menu" *ngIf="currentOption?.hasNotification && hasNotification">
            <div class="animated swing bell"></div>
          </div>
        </div>
      </ng-container>
      <div
        class="support-item"
        *ngIf="currentOption?.parent"
        (click)="setOption(currentOption, true)"
      >
        <div class="support-image">
          <img
            class="image"
            src="/assets/support/backArrow.png"
            [alt]="currentOption.parent?.label"
          />
        </div>
        <div class="support-text">
          <p class="text">Atrás</p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-reset-password [supportButton]="true" [resetModalStatus]="modalStatus"></app-reset-password>
